// extracted by mini-css-extract-plugin
export default {"base":"FooterLinks_base__Xe1Sf","isExternal":"FooterLinks_isExternal__5aSG0","externalLinkIcon":"FooterLinks_externalLinkIcon__a8pE-"};